import request from '../request';

export const getContentTypes = () =>
  request.get('contenttypes').then((res) => res);
